export enum EnumTipoEquipo {
    Ascensor = 1,
    Escalera = 2,
    Rampa = 3
}